// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__Ha+Ky","content":"Modal_content__gGb69","header":"Modal_header__fOQI0","body":"Modal_body__q5AFJ"};